export const Loading = () => <div className="loading">Loading...</div>
